// extracted by mini-css-extract-plugin
export default {"tableRow":"QuestionSelection_tableRow__VclwC","tableHeader":"QuestionSelection_tableHeader__3A-r7"};